import Event from "If_AdTool/common/event";
import createStyleSheet from "If_AdTool/common/createStyleSheet";
import CreateIframe from "If_AdTool/common/creatIframe";
import ide from "./ideTxt";
import SendUrls from "If_AdTool/common/sendUrl"

function google_float_i(adData,el){

    let {  slot=""} = adData;
    let cssContent = `
            .cl_list{
                width: 100%;
                height:100%;
                position: fixed;
                background: rgba(0, 0, 0, 0.5);
                bottom:0;left: 0;
                z-index: 999999;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .cl_list .content{
                width: 80%;
                height: 60%;
                position: relative;
            }
            .cl_list .content .box{
                width: 100%;
                height: 100%;
                background-color: rgba(255, 255, 255, 0.9);
            }
            .cl_list .content .close{
                position: absolute;
                visibility: visible;
                top: -34px; 
                right: -14px;
                width: 28px;
                height: 28px;
                opacity:1;
            }`;
    let id = "g"+window.IfengAmgr.uuid();
    cssContent = cssContent.replace(/cl_list/g,id);
    createStyleSheet(cssContent);
    const noAdFnId = id+"_noAdFn";
    const googleAdCode =`<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5912088984683438"
     crossorigin="anonymous"></script>
<ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-5912088984683438"
     data-ad-slot="${slot}"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
     const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
        // 选择目标节点
        let target = document.querySelector("ins.adsbygoogle[data-ad-client]");
        let observer = new MutationObserver((records) => {
            records.map(function (record) {
                if (record.target.getAttribute("data-ad-status") == "unfilled") {
                    observer.disconnect();
                    window.parent.${noAdFnId}();
                }
            });
        });
        observer.observe(target, {
            attribute: true,
            attributeFilter: ['data-ad-status'],
        });
</script>`
    const html= `<div class="content">
                    <div class="box"></div>
                    <img class="close" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA2VJREFUWEfVmEuoVVUcxn/fQBs4kZw0adIVNPKS0OuCQolS3KTXFSQwocElQXEmihKoEInSqCjoohBUEEFlSUpRlKBQVwVFRYVq0sSJ0qSBOfjkL+vodt+z915nn3PouGHBuXe9fuvxf3xLjPinEeejb0DbzwEPFkqs+XqnSPq1n01oBWh7CfAS8CbwWAK4CVxJv6N+Xvp9EfgEOCKpU5/N3BOg7SeAt1I5CXTKBUl/FWe1/QiwDFhRKDPAjKQzuYTZgLY/TmCfAx9I+j13kmhn+xlgK7AhQW7K6Z8FaPs34AFgl6RjOQNXtbE9CbwL3JA00TRWI6Dta8BZ4EVJN5oGzKm3HYs9CiyXtKiuTy2g7b+BQ5L25Ezcaxvbu4FpSQ9X9a0EtP0l8I+kMIqhfbbDcBZKWt9tkq6AySAeBVZLCvcxtM92uKOfgUuS5hjOHMDkSk6nO9eXQeSuKhlO3Mknyy6oG2C4kwWS3sidYBDtbH8G/FvexXsAbYdjPQ9M1Pk5278Ax3ONx3YY2bOSVtW4n/CT4c7GJV3otCsDvgM8L+npul1JE4YF7m2C7LHtLPCjpLerAP8AfpC0penYcibOaVMKjx8CL0haPAcwZSVxdFOSvmkCTOErjq7rTvYKl8Z7DfgaWNXJgu4cse0p4CtgrBz4ez3uNnAJMBKMP4F1kgL0bj5oexr4SNL8nN0rHc2dnUz/z7qf3eax/R+wWdLBMuB2YKOk8V4BS8cdfzYaT401hxf5VNKBYQLukbS35UIrAQd9xK0g6454GEbSE2TKwiuNJMRPuJlXJH2Xczx11trGkm2/DHzb1c2kix4h5ntJO5oAcwBy2pS8wX5graQIube/cqjbBrwqaWWvvq/GKiudebmP7RPAYUnvVQGGXLz8PycLS4vy9P5Kt9I9DO07uglrgoykNVKuyAsHouRq7mgovMgDZ7NS/s5ASQtHhru6yaL7qbcdeiQy+K4auUl2hiZ+v23YagJPbmhrnTbOEe6hjUM8bRmUwktKLpLTyTpNPMcP1tyT0MgPAfsG9PSxE7hapYWLHI07WLiTo/t4VIAsPr+dAqL8BJyreH57HFgDPJXK8J7fSjEzYuXrqYyluqoHzMhOvohSlJNNBtQ11OV2KsGO3hNwm4W07ZNtJG0n6LffLcEU1DiUT2TyAAAAAElFTkSuQmCC"></div>
                `;
    const floatEL = document.createElement('div');
    floatEL.innerHTML = html;
    floatEL.className = id;
    document.body.appendChild(floatEL);
    window[noAdFnId] =()=>{
        floatEL.style.display = 'none';
    };
    const iframeEl = floatEL.querySelector(`.content .box`);
    iframeEl.innerHTML ='';
    const iframeW = iframeEl.offsetWidth;
    const iframeH = iframeEl.offsetHeight;
    CreateIframe(iframeEl, googleAdCode, iframeW, iframeH);
    const closeBtn = floatEL.querySelector(`.content .close`);
    closeBtn.onclick =()=>{
        window[noAdFnId]()
    }
}

if(typeof  window.IfengAmgr !=undefined){
    window.IfengAmgr.tplLib.google_float_i = { render: google_float_i,version:"1.0.0"};
}